import * as React from 'react';
import Alert, {type AlertProps} from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

import { type MaintenanceWindow } from 'src/common/maintenance-window';

type Props = {
    maintenanceWindow: MaintenanceWindow | null;
}

/**
 * An alert to dynamically display on the login pages to inform users about current or future maintenance window
 * Dynamically reads the time and adjusts text accordingly
 */
export default function MaintenanceWindowLoginAlert({ maintenanceWindow, ...props }: Props & AlertProps) {
    // no need to show anything if there is no maintenance window
    if (!maintenanceWindow) {
        return null;
    }

    if (maintenanceWindow.isActive()) {
        const title = maintenanceWindow.getAlertTitle();

        const body = <>
            <p>The Reffie web platform is currently undergoing scheduled maintenance from {maintenanceWindow.getLocalizedStartTime()} to {maintenanceWindow.getLocalizedEndTime()}.  </p>
            <p>During this time, you will not be able to log in.
            However, all emails, messages and playbooks will be processed as usual.</p>
        </>;

        return <Alert severity="warning" {...props}>
            <AlertTitle>{title}</AlertTitle>
            { body }
        </Alert>;
    } else if (maintenanceWindow.isUpcoming()) {
        const title = maintenanceWindow.getAlertTitle();

        // slightly different text
        const body = <>
            <p>The Reffie web platform is scheduled for maintenance from {maintenanceWindow.getLocalizedStartTime()} to {maintenanceWindow.getLocalizedEndTime()}.  </p>
            <p>During this time, you will not be able to log in.
            However, all emails, messages and playbooks will be processed as usual.</p>
        </>;

        return <Alert severity="info" {...props}>
            <AlertTitle>{title}</AlertTitle>
            { body }
        </Alert>;
    } else {
        // it's in the past - don't show anything
        return null;
    }
}